<template lang="pug">
.d-contents
  slot(v-bind="{ upload, progress, loading, uploaded }")
</template>

<script>
import { rServices } from '@/plugins/api';

const mbToBytes = (mb) => Number(mb) * 1024 * 1024;

export default {
  components:  {},
  props: {
    /** RHandler Function([file, progress(), maxSize]) */
    uploadHandler: { type: Function, default: rServices.upload.uploadFile },
    maxSize: { type: Number, default: 10 }, // mb
  },
  data() {
    return {
      uploaded: [],

      progress: 0,
      loading: false,
    };
  },
  methods: {
    async upload(filesList = []) {
      const files = [...filesList].filter(({ size, name }) => {
        const maxSize = mbToBytes(this.maxSize);
        const isPassed = !maxSize || size <= maxSize;
        if (!isPassed) {
          this.$toast.error(`Файл «${name}» слишком большой`);
        }
        return isPassed;
      });

      if (files.length) {
        this.uploaded = [];
        this.progress = 0;
        this.loading = true;
        await this.uploadFiles(files).then((uploadFiles) => {
          if (uploadFiles?.length && !this.uploaded.length) {
            this.uploaded.push(...uploadFiles);
          }
        });
        this.loading = false;

        if (this.uploaded.length) {
          this.$emit('uploaded', this.uploaded);
        }
      }
    },
    uploadFiles(files) {
      const bullets = files.map((file) => this.uploadFile(file));
      return Promise.all(bullets).then((promisedBullets) => promisedBullets.filter(Boolean));
    },
    async uploadFile(file) {
      const args = [
        file,
        (progress) => {
          this.progress = progress;
        },
        this.maxSize,
      ];
      const { response, error } = await this.uploadHandler({ args });
      if (error) {
        return null;
      }

      return { data: response?.data?.data, file };
    },
  },
};
</script>
